/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import LoadingSkeleton from 'bundles/grading/components/common/LoadingSkeleton';

const styles = {
  container: () => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    mask-image: linear-gradient(to bottom, #000 25%, transparent 100%);
  `,
  section: () => css`
    padding: var(--cds-spacing-300) var(--cds-spacing-200);

    &:not(:first-of-type) {
      border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    }
  `,
  assignmentGradeLazyLoad: () => css`
    max-width: 300px;
  `,
  rubricProgressLazyLoad: () => css`
    margin-top: var(--cds-spacing-300);
    max-width: 170px;
  `,
  rubricSelectorLazyLoad: () => css`
    margin: var(--cds-spacing-50) 0 var(--cds-spacing-200) 0;
    max-width: 170px;
  `,
};

// Container for SGA left panel related components
const SGALazyLoadRightPanel: React.FC = () => {
  return (
    <div css={styles.container}>
      <div css={styles.section}>
        <LoadingSkeleton width="60%" height="24px" cssOverride={styles.assignmentGradeLazyLoad} />
        <LoadingSkeleton width="60%" height="24px" cssOverride={styles.rubricProgressLazyLoad} />
      </div>
      <div css={styles.section}>
        <LoadingSkeleton width="185px" height="48px" cssOverride={styles.rubricSelectorLazyLoad} />
        <LoadingSkeleton width="100%" height="255px" />
      </div>
    </div>
  );
};

export default SGALazyLoadRightPanel;
